"use client";

import { useOnboardingSteps } from "@/hooks/use-onboarding-steps";
import { cn } from "@/utils/utils";

const DOT_SIZE = 4;
const DOT_GAP = 4;
const initialBlackLineWidth = DOT_SIZE * 2 + DOT_GAP;

interface OnboardingStepperProps {
  className?: string;
}

export const OnboardingStepper = ({ className }: OnboardingStepperProps) => {
  const { shouldShowStepper, currentStepIndex, stepsCount, stepName } =
    useOnboardingSteps();

  if (!shouldShowStepper) {
    return null;
  }

  const completedSteps = currentStepIndex;
  const blackLineWidth =
    initialBlackLineWidth + completedSteps * (DOT_SIZE + DOT_GAP);

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <span
        key={currentStepIndex}
        className="text-[13px] text-muted-foreground duration-300 animate-in fade-in"
      >
        {stepName}
      </span>

      <div
        className="relative flex items-center"
        style={{
          paddingLeft: `${initialBlackLineWidth + DOT_GAP}px`,
        }}
      >
        {Array.from({ length: stepsCount }).map((_, index) => (
          <div
            key={index}
            className="rounded-full bg-muted-foreground/20"
            style={{
              marginRight: `${DOT_GAP}px`,
              width: `${DOT_SIZE}px`,
              height: `${DOT_SIZE}px`,
            }}
          />
        ))}
        <div
          className="absolute left-0 top-1/2 z-10 h-1 -translate-y-1/2 rounded-full bg-primary transition-all duration-300 ease-out"
          style={{ width: `${blackLineWidth}px` }}
        />
      </div>
    </div>
  );
};
